// extracted by mini-css-extract-plugin
export default {"ProfileImages":"IvfClinicActiveClients_ProfileImages__pUUuf"};